var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BaseManagePasswordComponent } from '@app/components/_shared/account/base-manage-password/base-manage-password.component';
var ChangePasswordComponent = /** @class */ (function (_super) {
    __extends(ChangePasswordComponent, _super);
    function ChangePasswordComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // BaseManagePasswordComponent template variables to be passed
        _this.templateSettings = {
            headerLegend: false,
            showMessagesTop: true,
            changePasswordMessage: true
        };
        return _this;
    }
    ChangePasswordComponent.route = 'change-password';
    return ChangePasswordComponent;
}(BaseManagePasswordComponent));
export { ChangePasswordComponent };



// WEBPACK FOOTER //
// ./src/app/components/account/change-password/change-password.component.ts.pre-build-optimizer.js